import _ from 'lodash'
import moment from 'moment'
import React from 'react'
import { Dropdown, Menu, Input, notification } from 'antd'
import { Icon } from '@ant-design/compatible'
import { UdModal, UdModalForm, aesEncrypt, createLoginMd5Key, http } from '@ud/admin-framework'
import { buildOtherAppLink, validators } from '../../utils'
import { appStore } from '../../stores/appStore'
import Avator from './avator.png'
import { UdMessageNotice } from '@ud/biz-library'
import './CenterHeader.less'
import {cryptoAes} from '../../utils/cryptoAes'


const CenterHeader: React.FC = () => {

  let userInfo = appStore.myUserData.profile
  const topApps = (appStore.myUserData.navigatorGroupMenus && appStore.myUserData.navigatorGroupMenus.TOP) || []
  let workOrder = topApps.find(n => n.customId == 'WORK-ORDER')
  let myFile = topApps.find(n => n.customId == 'MY-FILE')
  let myFlow = topApps.find(n => n.customId == 'MY-FLOW')

  const openChangePasswordModal = () => {
    let newPassword = ''
    UdModal.open({
      title: '修改密码',
      content: <UdModalForm items={[
        {
          label: '旧密码', name: 'oldPassWord', rules: [validators.required],
          render: <Input.Password type="password" />
        },
        {
          label: '新密码', name: 'passWord', rules: [validators.required, validators.password],
          render: <Input.Password type="password" onChange={(e) => newPassword = e.target.value} />,
        },
        {
          label: '确认新密码', name: 'passWordF',
          render: <Input.Password type="password" />,
          rules: [
            validators.required,
            validators.password,
            {
              validator: (rule: any, value: any, callback: any) => {
                if (value && newPassword !== value && value.length >= 8) {
                  callback('两次输入密码不一致')
                  return
                }
                callback()
              }
            }
          ],
        }
      ]} />,
      onOk: (values) => {
        const username = appStore.myUserData.profile.username

        const params = {
          username,
          // oldPassWord: cryptoAes.encrypt(values.oldPassWord, username),
          oldPassWord: aesEncrypt(values.oldPassWord, createLoginMd5Key(username)),
          // passWord: cryptoAes.encrypt(values.passWord, username),
          passWord: aesEncrypt(values.passWord, createLoginMd5Key(username)),
        }
        return http.post('/api/uaa/uaa/sso/ssoUpdatePassword', params).then(res => {
          notification.success({ message: '提示', description: '修改成功！请重新登录' })
          appStore.logout()
        })
      }
    })
  }

  const goToMyFile = () => {
    if (myFile) {
      window.location.href = buildOtherAppLink(myFile.customId, `/my_file/list?conditions=${JSON.stringify({ startTime: moment().subtract(7, 'days').format('YYYY-MM-DD HH:mm:ss'), endTime: moment().format('YYYY-MM-DD HH:mm:ss') })}`)
    }
  }

  const addTimeStamp = (path: string) => {
    const timestampString = new Date().valueOf().toString()
    if (path.indexOf('?') > -1) {
      const arr = path.split('?')
      let str = arr[0] + '?timestamp=' + timestampString + '&' + (arr[1] || '')
      return str
    } else {
      return path + '?timestamp=' + timestampString
    }
  }

  console.log(appStore.myUserData.urls)

  return (
    <div className="center-header">
      <div className="logo">
        <img src="image/logo.png" alt="1919管理中心" />
        <h1>管理中心</h1>
      </div>
      <div className="links">
        <div className="UdMessageNotification">
          {/* <UdMessageNotification {...UdMessageNotificationProps} getProjectCodes={() => appStore.myUserData.generalMenus}/> */}
          <UdMessageNotice
          // TODO:
            // gatewayUrl={appStore.myUserData.urls['message-bus']}
            token={() => {
              return (appStore.getToken()?.accessToken || '')
            }}
            userIdentification={userInfo.jobNumber}
            userIdentificationName={userInfo.name}
            pannelPopConfig={{}}
            onLinkTap={(link, message) => {
              let linkUrl = link.url
              if (linkUrl && linkUrl.startsWith('#/')) {
                const arr = linkUrl.split('#/')
                let path = addTimeStamp(arr[1] || '')

                linkUrl = '#/system/' + (message.sourceProjectCode) + '/' + encodeURIComponent(path)
                console.log(linkUrl, '链接拼接后完整路径')
                return linkUrl
              }
              linkUrl = addTimeStamp(linkUrl)
              const arr = linkUrl.split('#/')
              linkUrl = arr[0] + '#/' + encodeURIComponent(arr[1])
              console.log(linkUrl, '链接拼接后完整路径')
              return linkUrl
            }}
            messageSourceSystem={() => {
              return new Promise((resolve, reject) => {
                console.log(appStore.myUserData)
                const generalMenus = appStore.myUserData.generalMenus || []
                const systemConfig = generalMenus.map(item => {
                  return { label: item.text, value: item.application }
                }).filter(item => !!item)
                resolve(systemConfig)
              })
            }}
          />
        </div>
        {
          (workOrder || myFile || myFlow) &&
          <div className="links-item">
            <Dropdown
              overlay={<Menu className="desktop-links">
                {
                  workOrder && (
                    <Menu.Item>
                      <a href={buildOtherAppLink(workOrder.customId, '/work_order/list')}>
                        <Icon type={'file-search'} />我的工单
                      </a>
                    </Menu.Item>
                  )
                }
                {
                  workOrder && (
                    <Menu.Item>
                      <a href={buildOtherAppLink(workOrder.customId, '/work_order/add')}>
                        <Icon type={'plus'} />提交工单
                      </a>
                    </Menu.Item>
                  )
                }
                {
                  myFile && (
                    <Menu.Item>
                      <a onClick={goToMyFile}>
                        <Icon type={myFile!.icon!} />文件下载
                      </a>
                    </Menu.Item>
                  )
                }
                {
                  myFlow && (
                    <Menu.Item>
                      <a href={buildOtherAppLink(myFlow.customId, '/my-flow/TodoListTask')}>
                        <Icon type={myFlow!.icon!} />我的流程
                      </a>
                    </Menu.Item>
                  )
                }
              </Menu>}>
              <a className="ant-dropdown-link">
                <Icon type="desktop" />我的工作台
              </a>
            </Dropdown>
          </div>
        }

      </div>
      <div className="user-panel">
        <div className="user-info">
          <div className="info-title" >
            <span>{userInfo && userInfo.name}</span>
          </div>
        </div>
        <div className="avator">
          <img src={Avator} />
        </div>
        <div className="popover">
          <div className="user">
            <span className="nickname"><img src={Avator} /></span>
            <span>{userInfo && userInfo.name}</span>
          </div>
          <div className="operation">
            <div className="info-menu" onClick={openChangePasswordModal}>
              <span className="icon"><Icon type="safety-certificate" /></span>
              修改密码
            </div>
            <div className="info-menu" onClick={() => appStore.logout()}>
              <span className="icon"><Icon type="logout" /></span>
              退出
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}



export default CenterHeader
